import { createApi } from "@reduxjs/toolkit/query/react";
import { getLoggerBaseQuery, expApiBaseQuery, getExpApiBaseQueryWithBaseUrl } from "../common.js";
import { LIST_TAG } from "../utils.js";
import { NOTIFICATION_HUB_TAGS } from "./common.js";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
const notificationHubApi = createApi({
  reducerPath: "exp_notification_hub_rtkquery",
  baseQuery: getLoggerBaseQuery(expApiBaseQuery),
  endpoints: () => ({}),
  tagTypes: [LIST_TAG, ...Object.values(NOTIFICATION_HUB_TAGS)]
});
const notificationHubV1Api = createApi({
  reducerPath: "exp_notification_hub_v1_rtkquery",
  baseQuery: getLoggerBaseQuery(getExpApiBaseQueryWithBaseUrl(EnvironmentService.endpoints.notificationHub.url, false)),
  endpoints: () => ({}),
  tagTypes: [LIST_TAG, ...Object.values(NOTIFICATION_HUB_TAGS)]
});
export {
  notificationHubApi,
  notificationHubV1Api
};
//# sourceMappingURL=api.js.map
